import { useEffect } from "react";

import { useDispatch, useStore } from "@/redux/hooks";

import { getUserLocationData } from "../api/requests/getUserLocation";
import { updateLocation } from "../redux/action-creators/location";
import {
  getCity,
  getCountryCode,
  getHasLoadedLocationCookie,
  getPostalCode,
  getState,
} from "../redux/selectors/location";
import useDomainCountryCode from "./useDomainCountryCode";

export const useGoogleAnalyticsUserLocation = () => {
  const domainCountryCode = useDomainCountryCode();
  const store = useStore();
  const dispatch = useDispatch();

  async function setGoogleAnalyticsLocation() {
    if (typeof window === "undefined") {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    const hasLoadedLocationFromCookie = getHasLoadedLocationCookie(
      store.getState(),
    );
    if (!hasLoadedLocationFromCookie) {
      const location = await getUserLocationData(domainCountryCode);
      if (!location) {
        return;
      }

      updateLocation(dispatch, location, domainCountryCode);
    }

    const country = getCountryCode(store.getState());
    const countriesAllowingLocationCapture = ["US", "CA"];
    if (countriesAllowingLocationCapture.includes(country)) {
      window.dataLayer.push({
        location: {
          city: getCity(store.getState()),
          country,
          postalCode: getPostalCode(store.getState()),
          region: getState(store.getState()),
        },
      });
    }
  }

  useEffect(() => {
    setGoogleAnalyticsLocation();
  }, []);
};
